import routes from './routes'
import VueRouter from 'vue-router'
import isTodayBirthday from '@/utils/isTodayBirthday'
import { Notify, Dialog, Toast } from 'vant'

const router = new VueRouter({
    base: "/",
    routes: routes

})

import store from '@/store'
import nw from '@/nvwa/versionLast/index'

router.beforeEach((to, from, next) => {
    if (getQueryVariable("index")) {
        console.log('getQueryVariable')
        console.log(getQueryVariable("index"))
        window.location.replace(location.href.slice(0, location.href.indexOf('?') - 1) + "/#" + getQueryVariable("index"))
        // router.replace(getQueryVariable("index"))
        // next('/'+getQueryVariable("index"))
        return
    }
    next()
})

router.afterEach((to, from) => {
    console.log('afterEach', to, from)
    // Dialog.close()
    Notify.clear()
    Toast.clear()
    let loginAuth = () => {
        if (to.meta.needLogin && !store.getters['loginStatus/hasLogin']()) {
            Dialog.alert({
                title: '提示',
                message: '请先登录'
            }).then(() => {
                router.push('/afterLogin')
                // on close
            });
        } else if (store.getters['loginStatus/hasLogin']()) {
            //item.birthday
            if (to.name === 'Birthday') {
                return;
            }
            if (localStorage.getItem('lastBirthdayYear') ? JSON.parse(localStorage.getItem(lastBirthdayYear)) !== new Date().getFullYear() : true) {
                const today = new Date().toDateString();
                const lastQuerydate = localStorage.getItem('lastQuerydate');
                if (lastQuerydate !== today) {
                    localStorage.setItem('todayBirthdayQuery', JSON.stringify(false));
                    localStorage.setItem('lastUpdate', today);
                }
                if (!JSON.parse(localStorage.getItem('todayBirthdayisQueried'))) {
                    store.dispatch('loginStatus/getbirthdayList', {}).then((data) => {
                        localStorage.setItem("todayBirthdayisQueried", JSON.stringify(true));
                        data.data.forEach(item => {
                            if (item.employeeId === store.state.loginStatus.employeeInfo.employeeId) {
                                localStorage.setItem('birthdayPersonInfo', JSON.stringify({
                                    isLeader: item.employeeName === '陈醉' || item.employeeName === '贺培尔' ? true : false,
                                    name: item.employeeName,
                                    sex: item.sex
                                }))
                                nw.navigateTo({
                                    url: '/birthday'
                                })
                            }
                        })
                    }).catch((error) => {
                        console.error('捕获到错误:', error);
                    })
                }
            }
        }
    }
    if (!nw.UA.isUniApp && !nw.UA.isNvwa && to.meta.useApp) {
        if (!to.meta.needLogin || store.getters['loginStatus/hasLogin']()) {
            Dialog.confirm({
                title: "提示",
                message: "点击确定下载APP使用"
            }).then(() => {
                router.push('/downloadApp')
            }).catch(() => {
                loginAuth()
            })

        }
    }
    loginAuth()
})

export default router
